import { render } from "./myDetail.vue?vue&type=template&id=df6daf74&scoped=true"
import script from "./myDetail.vue?vue&type=script&lang=js"
export * from "./myDetail.vue?vue&type=script&lang=js"

import "./myDetail.vue?vue&type=style&index=0&id=df6daf74&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6daf74"]])

export default __exports__